export default __webpack_public_path__ + "69c03c51071839df62b8a04f218c22a4.png";